<template lang='pug'>
  div(
    :id="id"
    :key="_uid"
    )
</template>

<script>
export default {
  name: "Advertisement",
  props: {
    size: Array,
    path: String,
    viewports: Array,
    id: String
  },
  mounted() {
    const { path, size, id, viewports } = this;
    window.googletag.cmd.push(() => {
      var slot = window.googletag
        .defineSlot(path, size, id)
        

      var mapping = window.googletag.sizeMapping();

      viewports.forEach(viewport => {
        mapping.addSize(viewport[0], viewport[1]);
      });
      mapping = mapping.build();

      slot.defineSizeMapping(mapping);
      slot.addService(window.googletag.pubads());

      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      window.googletag.display(id);
    });
  },
  beforeDestroy() {
    window.googletag.cmd.push(() => {
        window.googletag.destroySlots();
    });
  }
};
</script>
